module.exports = __webpack_public_path__ + "img/c6.bda6f80e.svg";